import React from 'react';
import cn from 'classnames';

import Button from 'brandComponents/Button';
import Icon from 'brandComponents/Icon';

import {ENavigationItemViewAll} from '../../INavigationItem';

import {NavigationItemListViewAll} from './../index';
import {INavigationItemListProps} from './INavigationItemList';

const NavigationItemList = ({
	children,
	classNames,
	showTrigger,
	onTriggerClick,
	title,
	level = 'sub',
	viewAll = {url: '', show: ENavigationItemViewAll['None']},
	editorialContent,
	customSettings,
}: INavigationItemListProps) => {
	if (!children) {
		return null;
	}

	return (
		<ul className={cn(classNames, level)}>
			{showTrigger && (
				<li className="back">
					<Button
						onClick={onTriggerClick}
						variant="anything"
						classNames="navigation-trigger navigation-trigger__back"
					>
						<Icon name="arrow-left" width={12} height={12} />
						<span>{title}</span>
					</Button>
				</li>
			)}
			{children}
			{viewAll?.url && <NavigationItemListViewAll show={viewAll.show} url={viewAll.url} />}
			{customSettings?.showEditorialContent && editorialContent && (
				<li className="item-editorial-content">
					{editorialContent}
				</li>
			)}
		</ul>
	);
};

export default NavigationItemList;
